import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AgilityRiskService } from '../../providers/agility-risk.service';
import { RiskTemplate } from '../../models/risk-template';
import { ConfirmationModalComponent } from '../shared/modals/confirmation-modal/confirmation-modal.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AgilityRiskSpinnerService } from '../../providers/agility-risk-spinner.service';
import { AgilityRiskMessageService } from '../../providers/agility-risk-message.service';

@Component({
  selector: 'lib-risk-templates',
  templateUrl: './risk-templates.component.html',
  styleUrls: ['./risk-templates.component.scss']
})
export class RiskTemplatesComponent implements OnInit, OnDestroy {
  templatesSub: Subscription;
  deleteTemplateSub: Subscription;
  copyTemplateSub: Subscription;
  riskTemplates: RiskTemplate[];
  public confirmationDynamicDialogRef: DynamicDialogRef;
  public newTemplateId: any;

  constructor(private riskService: AgilityRiskService,
              private dialogService: DialogService,
              private translateService: TranslateService,
              private messageService: AgilityRiskMessageService,
              private router: Router,
              private route: ActivatedRoute,
              private spinner: AgilityRiskSpinnerService) {
  }

  ngOnInit(): void {
    this.spinner.start();
    this.templatesSub = this.riskService.getRiskTemplates().subscribe((riskTemplates: any) => {
      this.riskTemplates = riskTemplates?.content;
      this.spinner.stop();
    });
  }

  deleteTemplate(templateId: string): void {
    this.confirmationDynamicDialogRef = this.dialogService.open(ConfirmationModalComponent, {
      data: {
        body: this.translateService.instant('riskTemplates.deleteConfirmation')
      },
      header: this.translateService.instant('riskTemplates.deleteTitle'),
      width: '35%'
    });

    this.confirmationDynamicDialogRef.onClose.subscribe((result: any) => {
      if (result) {
        this.spinner.start();
        this.deleteTemplateSub = this.riskService.deleteRiskTemplate(templateId).subscribe({
          next: (response) => {
            this.riskTemplates = this.riskTemplates.filter(template => template.id !== templateId);
            this.messageService.success(
              this.translateService.instant('common.success'), this.translateService.instant('riskTemplates.deleteSuccessfully'));
            this.spinner.stop();
          },
          error: (err) => {
            this.messageService.error(
              this.translateService.instant('common.error'), this.translateService.instant('riskTemplates.deleteUnSuccessfully'));
            this.spinner.stop();
          }
        });
      }
    });
  }

  cloneTemplate(templateId: string): void {
    this.copyTemplateSub = this.riskService.copyRiskTemplate(templateId).subscribe({
      next: (response: any) => {
        this.messageService.success(
          this.translateService.instant('common.success'), this.translateService.instant('riskTemplates.cloneSuccessfully'));
        this.newTemplateId = response?.id;

        this.ngOnInit();
      }, error: (err) => {
        this.messageService.error(
          this.translateService.instant('common.error'), this.translateService.instant('riskTemplates.cloneUnSuccessfully'));
      }
    });
  }

  details(templateId?: string): void {
    this.router.navigate([`risk-template-management/${templateId ? templateId : ''}`], {relativeTo: this.route.parent});
  }

  ngOnDestroy(): void {
    this.templatesSub?.unsubscribe();
    this.confirmationDynamicDialogRef?.destroy();
  };
}
